import { registerModal } from 'features/Modal/ModalRegistry'
import FileUploadModal from './FileUploadModal.container'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'FILE_UPLOAD_MODAL'
registerModal(modalType, FileUploadModal)
export default modalProps =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {},
  })



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Files/FileUploadModal/FileUploadModal.action.js